import { createRoot } from 'react-dom/client'
import { AppProvider } from './context/AppContext/AppContext'
import { MainProduct } from './types'
import { App } from './components/App'

const container = document.getElementById('feature-product-2d-builder')!
const root = createRoot(container)


const mainProductJsonString = container.dataset["mainProductJsonString"] as string
const mainProduct = JSON.parse(mainProductJsonString) as MainProduct
const cart = JSON.parse(container.dataset["cartJsonString"] as string)

root.render(
  <AppProvider mainProduct={mainProduct} cart={cart}>
    <App /> 
  </AppProvider> 
)
